<script>
    import axios from 'axios';
    import {Listeners} from "../../../../../constants/listeners";
    import {nextTick} from "vue";
    import AdaptersDialog from "../../../../../component/adapters/Dialog.vue";
    import {store} from "../../../store";
    import InputText from "primevue/inputtext";

    export default {
        data() {
            return {
                name: "CreateNode",
                loading: false,
                error: null,
                nodeName: null,
                model: {},
                store: store,
            }
        },
        props: {
            tree: Object
        },
        methods: {
            save() {
                let self = this;
                if(!this.nodeName){
                    this.error = this.$t('lang.cluster.enter_folder_name');
                    return false;
                }

                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: {pid: this.model.id, name: this.nodeName}
                })
                    .then(function (response) {
                        self.onClose();

                        let parentNode = self.$parent.$_tree.getNodeById(self.model.id);
                        self.$parent.$_tree.appendChildNode(response.data, parentNode);

                        if (!parentNode.state.open) {
                            self.$parent.$_tree.openNode(parentNode, {
                                asyncCallback(){
                                    self.store.mutations.setNodesInfo(self.$parent.$_tree.getNodesInfo());
                                    self.$emitter.emit(Listeners.CLUSTER_REFRESH_FILTER);
                                }
                            });
                        } else {
                            self.store.mutations.setNodesInfo(self.$parent.$_tree.getNodesInfo());
                            self.$emitter.emit(Listeners.CLUSTER_REFRESH_FILTER);
                        }
                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });
            },
            onOpen() {
                this.error = null;
                this.loading = false;
                this.nodeName = null;

                this.$emitter.emit(this.getListenerId);
            },
            onClose() {
                this.$emitter.emit(this.getListenerCloseId);
            },

        },
        computed: {
            getUid() {
                return this.store.getters.uid();
            },
            getApiUrl(){
                return this.$config.API_URL + '/clustering/node/' + this.getUid;
            },
            getListenerId() {
                return Listeners.CLUSTER_CREATE_NODE_OPEN;
            },
            getListenerCloseId() {
                return Listeners.CLUSTER_CREATE_NODE_CLOSE;
            }
        },
        mounted() {
            this.$emitter.on(Listeners.CLUSTER_CREATE_NODE, model => {
                this.model  = model;
                this.onOpen();
            });
        },
        components: {
            AdaptersDialog,
            InputText,
        }
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getListenerId"
        :listener-close-id="getListenerCloseId"
        :header="$t('lang.cluster.create_new_folder')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="$t('lang.main.btn.save')"
    >
        <template #content>
            <div class="field">
                <label for="nodeName">{{ $t('lang.cluster.folder_name') }}</label>
                <InputText v-model="nodeName" ref="test" inputId="nodeName" @keyup.enter="save" />
            </div>
        </template>
    </AdaptersDialog>
</template>
